module.exports = __webpack_public_path__ + "img/Moldova.8d784b9a.svg";